/* eslint-disable import/no-internal-modules, no-new */

// Polyfill for creating CustomEvents on IE9/10/11
// From:
// https://github.com/krambuhl/custom-event-polyfill
// Which is in turn from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

import 'core-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime';
import noop from 'lodash/noop';
import wgxpath from 'wgxpath';

try {
  new window.CustomEvent('test');
} catch (e) {
  const CustomEvent = function (event, params) {
    const _params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined,
    };

    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, _params.bubbles, _params.cancelable, _params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}

try {
  // Now make sure the Event constructor works (it does not in IE9/10/11) and if it
  // fails then polyfill with CustomEvent
  new window.Event('test');
} catch (e) {
  window.Event = window.CustomEvent;
}

// JavaScript implementation of the DOM Level 3 XPath specification.
// It enables XPath evaluation for HTML documents in every browser.
wgxpath.install(window);

// Performance API polyfill
// All of our supported browsers implement the Performance API except
// Safari 6/7 which is a very small percentage of our overall listener base
// so instead of adding a large polyfill we just noop used functionality
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
const windowPerformancePolyfills = {
  navigation: null,
  onresourcetimingbufferfull: null,
  timing: null,
  clearMarks: noop,
  clearMeasures: noop,
  clearResourceTimings: noop,
  getEntries: noop,
  getEntriesByName: noop,
  getEntriesByType: noop,
  mark: noop,
  measure: noop,
  now: Date.now,
  setResourceTimingBufferSize: noop,
  toJSON: noop,
};

// no performance object so using all polyfills
if (!window.performance) {
  window.performance = windowPerformancePolyfills;
} else {
  // apply individual polyfills as necessary
  for (const polyfill in windowPerformancePolyfills) {
    if (!window.performance[polyfill]) {
      window.performance[polyfill] = windowPerformancePolyfills[polyfill];
    }
  }
}
